<!-- Wrapper -->
<div class="grid grid-cols-1 xl:grid-cols-2 gap-3 mt-6 sm:px-0">

  <!-- ===== SECTION 1 : TOTAL FACILITIES ===== -->
  <div class="bg-white rounded-[32px] p-4 sm:p-6 shadow-sm">

    <!-- Header -->
    <h2 class="text-xl sm:text-xl font-semibold text-[#0B0D5C] mb-6 sm:mb-8">
      {{ 'SALE.TOTAL_FACILITIES' | translate }}
      <span class="text-indigo-600 text-3xl sm:text-4xl font-bold ms-2">25</span>
    </h2>

    <!-- Cards -->
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">

      <!-- Card -->
      <div class="rounded-xl bg-[#E6FFF0] p-4 sm:p-5">
        <div class="flex justify-between mb-4">
          <div class="h-10 w-10 flex items-center justify-center rounded-full bg-green-500">
            <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path d="M4 19V5" />
              <path d="M10 19V9" />
              <path d="M16 19V13" />
            </svg>
          </div>

          <svg class="w-10 sm:w-12 h-10 sm:h-12 text-green-300" fill="none" stroke="currentColor" stroke-width="3" viewBox="0 0 24 24">
            <path d="M3 17c3-5 6-5 9-2s6 2 9-5" />
          </svg>
        </div>

        <p class="text-xl sm:text-xl font-bold text-[#0B0D5C]">25</p>
        <p class="text-sm text-slate-600 mt-1">
          {{ 'SALE.PERFORMING_FACILITIES' | translate }}
        </p>
      </div>

      <!-- Card -->
      <div class="rounded-xl bg-[#FFE6E9] p-4 sm:p-5">
        <div class="flex justify-between mb-4">
          <div class="h-10 w-10 flex items-center justify-center rounded-full bg-rose-500">
            <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="9" />
              <path d="M12 6v6l4 2" />
            </svg>
          </div>

          <svg class="w-10 sm:w-12 h-10 sm:h-12 text-rose-300" fill="none" stroke="currentColor" stroke-width="3" viewBox="0 0 24 24">
            <path d="M3 7c3 5 6 5 9 2s6-2 9 5" />
          </svg>
        </div>

        <p class="text-xl sm:text-xl font-bold text-[#0B0D5C]">05</p>
        <p class="text-sm text-slate-600 mt-1">
          {{ 'SALE.NON_PERFORMING_FACILITIES' | translate }}
        </p>
      </div>

      <!-- Card -->
      <div class="rounded-[28px] bg-[#FFF4DE] p-4 sm:p-5">
        <div class="flex justify-between mb-4">
          <div class="h-10 w-10 flex items-center justify-center rounded-full bg-orange-400">
            <svg class="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 17l-5 3 1-6-4-4 6-1 2-5 2 5 6 1-4 4 1 6z" />
            </svg>
          </div>

          <svg class="w-10 sm:w-12 h-10 sm:h-12 text-orange-300" fill="none" stroke="currentColor" stroke-width="3" viewBox="0 0 24 24">
            <path d="M3 15c3-2 6-2 9 2s6 4 9-2" />
          </svg>
        </div>

        <p class="text-xl sm:text-xl font-bold text-[#0B0D5C]">07</p>
        <p class="text-sm text-slate-600 mt-1">
          {{ 'SALE.NEW_FACILITIES_CURRENT_MONTH' | translate }}
        </p>
      </div>

    </div>
  </div>

  <!-- ===== SECTION 2 : TOTAL EXPOSURE ===== -->
  <div class="bg-white rounded-[32px] p-3 md:p-6 shadow-sm flex justify-center flex-col">

    <h2 class="text-[20px] font-semibold text-[#0B0D5C] mb-5">
      {{ 'SALE.TOTAL_EXPOSURE_AMOUNT' | translate }}
      <span class="text-indigo-600 text-3xl sm:text-4xl font-bold ms-2">500</span>
      <span class="text-indigo-400 text-base font-semibold ms-1">
        {{ 'SALE.MILLIONS' | translate }}
      </span>
    </h2>

    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">

      <!-- Card 1 -->
      <div class="rounded-[20px] bg-[#F3ECFF] p-4">
        <div class="flex justify-between mb-4">
          <img src="/public/Icon (1).png" class="h-8" />
          <img src="/public/Group 5333.png" alt="" class="h-6" />
        </div>

        <p class="text-xl font-bold text-[#0B0D5C]">200</p>
        <p class="text-sm text-[#444A6D] mt-1">
          {{ 'SALE.PERFORMING_AMOUNT' | translate }}
        </p>
      </div>

      <!-- Card 2 -->
      <div class="rounded-[20px] bg-[#E5F4FF] p-4">
        <div class="flex justify-between mb-4">
          <img src="/public/Icon (2).png" class="h-8" />
          <img src="/public/Group 1000006262.png" alt="" class="h-6" />
        </div>

        <p class="text-xl font-bold text-[#0B0D5C]">10</p>
        <p class="text-sm text-[#444A6D] mt-1">
          {{ 'SALE.NON_PERFORMING_AMOUNT' | translate }}
        </p>
      </div>

      <!-- Card 3 -->
      <div class="rounded-[20px] bg-[#E9E9FF] p-4">
        <div class="flex justify-between mb-4">
          <img src="/public/Icon (3).png" class="h-8" />
          <span class="text-indigo-400">↗</span>
        </div>

        <p class="text-xl font-bold text-[#0B0D5C]">100</p>
        <p class="text-sm text-[#444A6D] mt-1">
          {{ 'SALE.NEW_FACILITIES_CURRENT_MONTH' | translate }}
        </p>
      </div>

      <!-- Card 4 -->
      <div class="rounded-[20px] bg-[#DFFFFB] p-4">
        <div class="flex justify-between mb-4">
          <img src="/public/Icon (4).png" class="h-8" />
          <span class="text-teal-400">↗</span>
        </div>

        <p class="text-xl font-bold text-[#0B0D5C]">200</p>
        <p class="text-sm text-[#444A6D] mt-1">
          {{ 'SALE.AVERAGE_FACILITY_SIZE_AMOUNT' | translate }}
        </p>
      </div>

    </div>
  </div>

</div>

<app-sale-report class="p-4 sm:p-6"></app-sale-report>